var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider-container",class:{ [_vm.theme]: true }},[_c('div',{staticClass:"divider"}),_c('div',{staticClass:"text",class:{ [_vm.theme]: true },style:({ color: _vm.textColor })},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"divider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }